import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    getProviderConfigRequestKey,
    ProviderConfigDetailFetchPayloadType,
    ProviderConfigDetailFetchSuccessPayloadType,
    ProviderConfigDetailStateType,
    ProviderConfigDetailUpdatePayloadType,
    ProviderConfigDetailUpdateSuccessPayloadType,
    ProviderConfigStructureCreatePayloadType,
    ProviderConfigStructureFetchPayloadType,
    ProviderConfigStructureFetchSuccessPayloadType,
    ProviderConfigStructureUpdatePayloadType
} from 'src/types/providerConfigDetail';

const initialState: ProviderConfigDetailStateType = {
    data: null,
    structureData: null,
    dataKey: null,
    structureKey: null,
    loading: false,
    structureLoading: false,
    error: false,
};

export const providerConfigDetailSlice = createSlice({
    name: 'providerConfigDetail',
    initialState,
    reducers: {
        getProviderConfigDetailFetch: (state, _action: PayloadAction<ProviderConfigDetailFetchPayloadType>) => {
            state.loading = true;
            state.error = false;
        },
        getProviderConfigDetailFetchSuccess: (
            state,
            action: PayloadAction<ProviderConfigDetailFetchSuccessPayloadType>
        ) => {
            state.data = action.payload.data;
            state.dataKey = getProviderConfigRequestKey(
                action.payload.request.idProvider,
                action.payload.request.system
            );
            state.loading = false;
        },
        getProviderConfigDetailFetchFailure: (state) => {
            state.data = null;
            state.dataKey = null;
            state.loading = false;
            state.error = true;
        },
        updateProviderConfigDetailFetch: (state, _action: PayloadAction<ProviderConfigDetailUpdatePayloadType>) => {
            state.loading = true;
            state.error = false;
        },
        updateProviderConfigDetailFetchSuccess: (
            state,
            action: PayloadAction<ProviderConfigDetailUpdateSuccessPayloadType>
        ) => {
            state.data = action.payload.data;
            state.dataKey = getProviderConfigRequestKey(
                action.payload.request.idProvider,
                action.payload.request.system
            );
            state.loading = false;
        },
        updateProviderConfigDetailFetchFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
        getProviderConfigStructureFetch: (state, _action: PayloadAction<ProviderConfigStructureFetchPayloadType>) => {
            state.structureLoading = true;
            state.error = false;
        },
        getProviderConfigStructureFetchSuccess: (
            state,
            action: PayloadAction<ProviderConfigStructureFetchSuccessPayloadType>
        ) => {
            state.structureData = action.payload.data;
            state.structureKey = getProviderConfigRequestKey(
                action.payload.request.idProvider,
                action.payload.request.system
            );
            state.structureLoading = false;
        },
        getProviderConfigStructureFetchFailure: (state) => {
            state.structureData = null;
            state.structureKey = null;
            state.structureLoading = false;
            state.error = true;
        },
        createProviderConfigStructureFetch: (state, _action: PayloadAction<ProviderConfigStructureCreatePayloadType>) => {
            state.loading = true;
            state.error = false;
        },
        createProviderConfigStructureFetchSuccess: (state) => {
            state.loading = false;
        },
        createProviderConfigStructureFetchFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
        updateProviderConfigStructureFetch: (state, _action: PayloadAction<ProviderConfigStructureUpdatePayloadType>) => {
            state.loading = true;
            state.error = false;
        },
        updateProviderConfigStructureFetchSuccess: (state) => {
            state.loading = false;
        },
        updateProviderConfigStructureFetchFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
        clearProviderConfigDetail: () => initialState,
    },
});

export const {
    getProviderConfigDetailFetch,
    getProviderConfigDetailFetchSuccess,
    getProviderConfigDetailFetchFailure,
    updateProviderConfigDetailFetch,
    updateProviderConfigDetailFetchSuccess,
    updateProviderConfigDetailFetchFailure,
    getProviderConfigStructureFetch,
    getProviderConfigStructureFetchSuccess,
    getProviderConfigStructureFetchFailure,
    createProviderConfigStructureFetch,
    createProviderConfigStructureFetchSuccess,
    createProviderConfigStructureFetchFailure,
    updateProviderConfigStructureFetch,
    updateProviderConfigStructureFetchSuccess,
    updateProviderConfigStructureFetchFailure,
    clearProviderConfigDetail,
} = providerConfigDetailSlice.actions;

export default providerConfigDetailSlice.reducer;
